import { render } from "./estimatedDate.vue?vue&type=template&id=6d3e870a"
import script from "./estimatedDate.vue?vue&type=script&lang=js"
export * from "./estimatedDate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__